/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strava_Too_Many_RequestsInputs */

const en_us2_strava_too_many_requests = /** @type {(inputs: Strava_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts in a short time. Try again later.`)
};

const pt_br2_strava_too_many_requests = /** @type {(inputs: Strava_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas tentativas em pouco tempo. Tente mais tarde.`)
};

const pt_pt2_strava_too_many_requests = /** @type {(inputs: Strava_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas tentativas em pouco tempo. Tente mais tarde.`)
};

/** @type {(inputs: Strava_Too_Many_RequestsInputs) => LocalizedString} */
const es_419_strava_too_many_requests = en_us2_strava_too_many_requests;

/** @type {(inputs: Strava_Too_Many_RequestsInputs) => LocalizedString} */
const fr_fr2_strava_too_many_requests = en_us2_strava_too_many_requests;

/** @type {(inputs: Strava_Too_Many_RequestsInputs) => LocalizedString} */
const de_de2_strava_too_many_requests = en_us2_strava_too_many_requests;

/** @type {(inputs: Strava_Too_Many_RequestsInputs) => LocalizedString} */
const it_it2_strava_too_many_requests = en_us2_strava_too_many_requests;

/**
* | output |
* | --- |
* | "Too many attempts in a short time. Try again later." |
*
* @param {Strava_Too_Many_RequestsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const strava_too_many_requests = /** @type {((inputs?: Strava_Too_Many_RequestsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strava_Too_Many_RequestsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_strava_too_many_requests(inputs)
	if (locale === "es-419") return es_419_strava_too_many_requests(inputs)
	if (locale === "pt-PT") return pt_pt2_strava_too_many_requests(inputs)
	if (locale === "fr-FR") return fr_fr2_strava_too_many_requests(inputs)
	if (locale === "de-DE") return de_de2_strava_too_many_requests(inputs)
	if (locale === "it-IT") return it_it2_strava_too_many_requests(inputs)
	return en_us2_strava_too_many_requests(inputs)
});
export { strava_too_many_requests as "strava.too_many_requests" }